export default __webpack_public_path__ + "static/media/SWT1380.34I-35069_-23152_0.6a578adc.jpg";